/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TabList from './tab/tab-list';
import styles from './tabs.module.scss';

const Tabs = ({ children, type = 'calendar', gtmClass }) => {
  const showTabs = children.length !== 0;
  const [activeTab, setActiveTab] = useState({
    label: `${children[0]?.props?.label}_0`,
    content: children[0]?.props?.content,
  });

  function onClickTabItem(tab) {
    setActiveTab({ label: tab.label, content: tab.content });
  }

  return (
    <div className={styles[type]}>
      <div className={styles.tabsHeader}>
        {showTabs && (
          <TabList
            onClick={onClickTabItem}
            items={children}
            activeTab={activeTab}
            type={type}
            gtmClass={gtmClass}
          />
        )}
      </div>
      <div className={styles.tabContent}>
        {children.map((child, index) => {
          if (child === null || `${child?.props?.label}_${index}` !== activeTab.label)
            return undefined;
          return child.props.children;
        })}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.any).isRequired,
  type: PropTypes.oneOf(['calendar', 'providers']),
  gtmClass: PropTypes.string,
};

export default Tabs;
